import {Component,ElementRef, NgZone, ViewChild, Inject, Optional, OnInit } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';
import { Router,ActivatedRoute } from '@angular/router';
import { NodeSelectorDialogBoxComponent} from 'app/main/apps/estructura-jerarquica/dialog/node-selector-dialog-box.component';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector   : 'dialog-box-evaluaciones-select',
    templateUrl: './dialog-box-evaluaciones.component.html',
    styleUrls  : ['./dialog-box-evaluaciones.component.scss']
})
export class SelectEvaluacionesUsuarioComponent
{
    LOCAL_DATA: Usuario = new Usuario({});
    displayedColumns: string[] = ['nombre','estado','version','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin'];

    constructor(public dialog: MatDialog,
                public userService: UsersService,
                private _snackBar: MatSnackBar,
                public dialogRef: MatDialogRef<SelectEvaluacionesUsuarioComponent>,
                public router: Router,
                public translate: TranslateService,
                private route: ActivatedRoute,
                private service: UsersService,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: Usuario) {
                console.log(data);
                this.LOCAL_DATA = new Usuario(data);
                this.LOCAL_DATA.evaluaciones.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
    }

    ngOnInit() {
      this.service.get(this.LOCAL_DATA.id).pipe().subscribe(req => {
        this.LOCAL_DATA = new Usuario(req.body);
        this.LOCAL_DATA.evaluaciones.sort((a, b) => (a.nombre > b.nombre) ? 1 : -1);
      });

    }

    closeDialog(): void
    {
      console.log('im here');
      this.dialogRef.close({event: 'Add', data: this.LOCAL_DATA});
    }


    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 5000,
      });
    }

}
